{
  "version": 1,
  "asset_id": "41713d76-5ad6-4366-bfab-76d3ac36fec3",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/41713d76-5ad6-4366-bfab-76d3ac36fec3/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/41713d76-5ad6-4366-bfab-76d3ac36fec3/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-480w.webp",
  "original_filename": "destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-480w.webp",
  "size": 19424,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:59Z"
}
